import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { Icon } from "@/components/common/Icon";
import { CTASection } from "@/components/home/CTASection";
import { useT } from "@/context/LanguageContext";

export default function Industries() {
  const { t, lang } = useT();
  const [industries, setIndustries] = useState([]);
  useEffect(() => { api.get("/industries").then((r) => setIndustries(r.data)).catch((e) => console.error("Failed to load industries:", e)); }, [lang]);

  return (
    <div data-testid="industries-page">
      <PageHero
        overline={t("industriesPage.heroOverline")}
        title={t("industriesPage.heroTitle")}
        subtitle={t("industriesPage.heroSubtitle")}
        crumbs={[{ label: t("industriesPage.heroOverline") }]}
        image="https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg"
      />
      <section className="bg-white py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {industries.map((ind, i) => (
              <Reveal key={ind.name} delay={(i % 3) * 0.06}>
                <div data-testid={`industry-detail-${i}`} className="group flex h-full flex-col overflow-hidden rounded-xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                  {ind.image && (
                    <div className="h-44 overflow-hidden">
                      <img src={ind.image} alt={ind.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                    </div>
                  )}
                  <div className="p-7">
                    <div className="flex h-12 w-12 items-center justify-center rounded-md bg-ink/5 text-ink transition-colors group-hover:bg-gradient-to-br group-hover:from-[#1E73BE] group-hover:to-[#16B894] group-hover:text-white">
                      <Icon name={ind.icon} size={24} weight="duotone" />
                    </div>
                    <h3 className="mt-5 font-heading text-lg font-semibold text-ink">{ind.name}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-600">{ind.desc}</p>
                    <Link to="/contact?type=quote" className="mt-4 inline-block text-sm font-semibold text-teal hover:underline">
                      {t("industriesPage.sourceFor")}
                    </Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
}
